import axios from 'axios'
import {API_URL} from '../../firebase'

// Create a Checkout Session with the selected plan ID
export const createCheckoutSession = (params) => {
    return axios.post(`${API_URL}/create-checkout-session`, params)
}